const moduleRoutes = [
    {
        path: '/sla-setup',
        name: 'slaSetups',
        children: [
            {
                path: '',
                name: 'slaSetupList',
                component: () => import('@/modules/sla_setup/list/List.vue'),
                meta: {
                    resource: 'sla-setups',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'MCU SLA Setup',
                    breadcrumbs: [{ title: 'MCU SLA Setup', routeName: 'slaSetupList' }]
                }
            },
            {
                path: 'new',
                name: 'slaSetupNew',
                component: () => import('@/modules/sla_setup/entry/New.vue'),
                meta: {
                    resource: 'sla-setups',
                    action: 'create',
                    layout: 'default',
                    auth: true,
                    title: 'New MCU SLA Setup',
                    breadcrumbs: [
                        { title: 'MCU SLA Setup', routeName: 'slaSetupList' },
                        { title: 'New', routeName: 'slaSetupNew' }
                    ]
                }
            },
            {
                path: ':id/edit',
                name: 'slaSetupEdit',
                component: () => import('@/modules/sla_setup/entry/Edit.vue'),
                meta: {
                    resource: 'sla-setups',
                    action: 'edit',
                    layout: 'default',
                    auth: true,
                    title: 'Edit MCU SLA Setup',
                    breadcrumbs: [
                        { title: 'MCU SLA Setup', routeName: 'slaSetupList' },
                        { title: 'Edit', routeName: 'slaSetupEdit' }
                    ]
                }
            }
        ]
    }
]

export default moduleRoutes
